import dayjs, {formatLocaleDate} from '@/dayjs'
import {StyledDateRangeMonthRadioGroup, StyledDateRangeMonthRadioItem} from './style'
import {capitalize} from '@/utilities/helpers'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'

interface DateRangeMonthSelectorProps {
    selectedMonth: number
    onMonthChange: (month: number) => void
    isAllYearSelected?: boolean
}

// Generate months dynamically using dayjs
const generateMonths = () => {
    return Array.from({length: 12}, (_, index) => ({
        label: capitalize(formatLocaleDate(dayjs().month(index).toDate(), 'MMMM')),
        value: index
    }))
}

export const DateRangeMonthSelector = ({
    selectedMonth,
    onMonthChange,
    isAllYearSelected
}: DateRangeMonthSelectorProps) => {
    const months = generateMonths()

    const handleMonthSelect = (value: string) => {
        if (value) {
            onMonthChange(parseInt(value, 10))
        }
    }

    return (
        <StyledDateRangeMonthRadioGroup
            type="single"
            value={selectedMonth.toString()}
            onValueChange={handleMonthSelect}
        >
            <Grid columns={3} gap={3} fullWidth>
                {months.map(month => (
                    <StyledDateRangeMonthRadioItem
                        key={month.value}
                        value={month.value.toString()}
                        $isSelected={selectedMonth === month.value || !!isAllYearSelected}
                        $isDisabled={!!isAllYearSelected}
                    >
                        {month.label}
                    </StyledDateRangeMonthRadioItem>
                ))}
            </Grid>
        </StyledDateRangeMonthRadioGroup>
    )
}
